'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (inputValue, bridge) {
    return inputValue.split(bridge).map(function (obj) {
        switch (obj.length) {
            case 0:
                return '00';
            case 1:
                return '0' + obj;
            default:
                return obj;
        }
    }).join(bridge);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/returnValidTime.js
// module id = 70
// module chunks = 0